import { createRouter, createWebHistory } from 'vue-router';
import Layout from "@/layout/Layout.vue"; // 替换为你的视图组件路径
import Home from '@/home/Index.vue';
import Home2 from '@/home/Index2.vue';
import Invest from '@/pages/Invest.vue';
import Token from '@/pages/Token.vue';
import Affiliate from '@/pages/Affiliate.vue';
import Contest from '@/pages/Contest.vue';
import About from '@/company/About.vue';
import Blog from '@/news/Blog.vue';
import How from '@/pages/How.vue';
import Reports from '@/pages/Reports.vue';
import Profile from '@/pages/Profile.vue';
import Article from '@/news/Article.vue';
import Contacts from '@/pages/Contacts.vue';
import Privacy from '@/pages/Privacy.vue';
import TermsOfUse from '@/pages/TermsOfUse.vue';
import App from '@/pages/App.vue';
import Faq from '@/pages/Faq.vue';
import Signin from '@/pages/Signin.vue';
import Signup from '@/pages/Signup.vue';
import Forgot from '@/pages/Forgot.vue';
import Error from '@/pages/404.vue';

import Products from '@/earnings/Products.vue';
import ProductDetail from '@/earnings/ProductDetail.vue';
import DailyRewards from '@/earnings/DailyRewards.vue';
import BecomePromoter from '@/earnings/BecomePromoter.vue';
import Talk from '@/user/Talk.vue';
// import About from '@/about/Index.vue';

import DashboardLayout from "@/layout/DashboardLayout.vue";
import Dashboard from "@/user/Dashboard.vue";
import Deposit from "@/user/Deposit.vue";
import Withdraw from "@/user/Withdraw.vue";
import Transactions from "@/user/Transactions.vue";
import Orders from "@/user/Orders.vue";
import Referrals from "@/user/Referrals.vue";
import Wallets from "@/user/Wallets.vue";
import Settings from "@/user/Settings.vue";
import Support from "@/user/Support.vue";


const routes = [
    {
        path: '/',
        name: 'Home',
        component: Layout,
        children: [
            {
                path: '',
                name: 'Home',
                component: Home
            },
            {
                path: '/Products',
                name: 'Products',
                component: Products
            },
            {
                path: '/ProductDetail',
                name: 'ProductDetail',
                component: ProductDetail
            },
            {
                path: '/Invest',
                name: 'Invest',
                component: Invest
            },
            {
                path: '/Token',
                name: 'Token',
                component: Token
            },
            {
                path: '/Affiliate',
                name: 'Affiliate',
                component: Affiliate
            },
            {
                path: '/Contest',
                name: 'Contest',
                component: Contest
            },
            {
                path: '/About',
                name: 'About',
                component: About
            },
            {
                path: '/DailyRewards',
                name: 'DailyRewards',
                component: DailyRewards
            },
            {
                path: '/BecomePromoter',
                name: 'BecomePromoter',
                component: BecomePromoter
            },
            {
                path: '/Blog',
                name: 'Blog',
                component: Blog
            },
            {
                path: '/How',
                name: 'How',
                component: How
            },
            {
                path: '/Reports',
                name: 'Reports',
                component: Reports
            },
            {
                path: '/Profile',
                name: 'Profile',
                component: Profile,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/Article',
                name: 'Article',
                component: Article
            },
            {
                path: '/Contacts',
                name: 'Contacts',
                component: Contacts
            },
            {
                path: '/Faq',
                name: 'Faq',
                component: Faq
            },
            {
                path: '/App',
                name: 'App',
                component: App
            },
            {
                path: '/Privacy',
                name: 'Privacy',
                component: Privacy
            },
            {
                path: '/Privacy',
                name: 'Privacy',
                component: Privacy
            },
            {
                path: '/TermsOfUse',
                name: 'TermsOfUse',
                component: TermsOfUse
            },
        ],
    },
    // 添加其他路由
    {
        path: '/Dashboard',
        name: 'Dashboard',
        component: DashboardLayout,
        meta: {
            requireAuth: true
        },
        children: [
            {
                path: '',
                name: 'Dashboard',
                component: Dashboard,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/Deposit',
                name: 'Deposit',
                component: Deposit,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/Withdraw',
                name: 'Withdraw',
                component: Withdraw,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/Transactions',
                name: 'Transactions',
                component: Transactions,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/Orders',
                name: 'Orders',
                component: Orders,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/Referrals',
                name: 'Referrals',
                component: Referrals,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/Wallets',
                name: 'Wallets',
                component: Wallets,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/Settings',
                name: 'Settings',
                component: Settings,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/Support',
                name: 'Support',
                component: Support,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/Talk',
                name: 'Talk',
                component: Talk,
                meta: {
                    requireAuth: true
                }
            },
        ]
    },
    {
        path: '/Signin',
        name: 'Signin',
        component: Signin,
    },
    {
        path: '/Signup',
        name: 'Signup',
        component: Signup,
    },
    {
        path: '/Forgot',
        name: 'Forgot',
        component: Forgot,
    },
    {
        path: '/Error',
        name: 'Error',
        component: Error,
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        // if (savedPosition) {
        //     return savedPosition;  // 返回时滚动到上次保存的位置
        // } else {
        //     window.scrollTo(0, 0);
        //     return { top: 0 };  // 路由切换时滚动到顶部
        // }
        return {
            top: 0 ,
            behavior: 'instant', //smooth 平滑滚动到目标位置 instant 直接瞬间滚动，无动画
        };  // 路由切换时滚动到顶部
    }
});

router.beforeEach((to, from, next) => {
    // 检查路由的 meta 字段中是否存在 requiresAuth，如果存在且为 true，则需要验证登录状态
    // console.log("拦截获取token: ", window.localStorage.getItem('cms-token'))
    if (to.meta.requireAuth && !window.localStorage.getItem('mine-token')) {
        // 如果需要登录且用户未登录，则重定向到登录页面
        next({path: "/Signin"});
    } else {
        const routeExists = router.getRoutes().some(route => route.name === to.name);
        if (!routeExists) {
            next(from.fullPath);
        }else{
            // 允许访问该路由
            next();
        }
    }
});

export default router;
